/* Hook para verificar créditos trial do usuário */
import { useState, useEffect } from 'react';
import { getUserTier } from '../api/profile';
import type { CreditsInfo, AuthUser } from '../types';

export interface UseTrialCreditReturn {
  creditsInfo: CreditsInfo | null;
  loadingCredits: boolean;
  refreshCredits: () => void;
}

/**
 * Busca créditos e tier do usuário autenticado.
 * Atualiza automaticamente quando user muda.
 */
export function useTrialCredit(user: AuthUser | null): UseTrialCreditReturn {
  const [creditsInfo, setCreditsInfo] = useState<CreditsInfo | null>(null);
  const [loadingCredits, setLoadingCredits] = useState(false);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  useEffect(() => {
    if (!user) {
      setCreditsInfo(null);
      return;
    }

    setLoadingCredits(true);
    getUserTier()
      .then((data) => {
        setCreditsInfo({
          credits: data.credits,
          tier: data.tier,
          isTrial: data.trial,
        });
      })
      .catch(() => {
        // Erro silencioso — não bloqueia o chat
        setCreditsInfo(null);
      })
      .finally(() => {
        setLoadingCredits(false);
      });
  }, [user?.sub, refreshTrigger]);

  function refreshCredits() {
    setRefreshTrigger((n) => n + 1);
  }

  return { creditsInfo, loadingCredits, refreshCredits };
}
